export type CarouselItem = {
  header: string;
  title: string;
  image: string;
  doc: string;
};

export const carouselItems: CarouselItem[] = [
  {
    header: "header_1",
    title: "noticia_1",
    image: "/img/laboratory/carousel/bg-noticia1.jpg",
    doc: "https://uady.mx/noticias/url/reconocen-a-estudiantes-uady-por-participar-en-programa-internacional-de-investigacion-uady",
  },
  {
    header: "header_2",
    title: "noticia_2",
    image: "/img/laboratory/carousel/bg-noticia2.png",
    doc: "#",
  },
  {
    header: "header_3",
    title: "noticia_3",
    image: "/img/laboratory/carousel/bg-noticia3.jpg",
    doc: "#",
  },
  {
    header: "header_4",
    title: "noticia_4",
    image: "/img/researchLines/MayanOnChip/Convenio.jpg",
    doc: "https://www.businesswire.com/news/home/20260528529437/en/Altium-Education-Celebrates-First-Mayan-on-Chip-Cohort-Advancing-Semiconductor-Talent-Development-in-Yucatn",
  },
  {
    header: "header_5",
    title: "noticia_5",
    image: "/img/events/convenio.png",
    doc: "http://industria4fiuady.com/researchLines",
  },
];